import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {Observable, Subscription} from "rxjs";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../../store/reducers";
import {
  citizenGetAllSectors
} from "../../../../../store/entities/citizens/citizens-services-sector/citizens-services-sector.actions";
import {
  selectModifiedCitizenSector
} from "../../../../../store/entities/citizens/citizens-services-sector/citizens-services-sector.selectors";
import {
  CitizensServicesSector
} from "../../../../../store/entities/citizens/citizens-services-sector/citizens-services-sector.model";
import {
  CitizensServicesCategory,
  SocialGroups
} from "../../../../../store/entities/citizens/citizens-services-category/citizens-services-category.model";
import {enumToObjectArray} from "../../../../../shared/functions/functions";
import {ServiceClusterEnumTranslate} from "../../../../../interfaces/global.interface";
import {
  selectModifiedCitizensServiceCategory
} from "../../../../../store/entities/citizens/citizens-services-category/citizens-services-category.selectors";
import {
  citizenGetCategories
} from "../../../../../store/entities/citizens/citizens-services-category/citizens-services-category.actions";
import {getAllRegions} from "../../../../../store/entities/locations/regions/regions.actions";
import {selectAllRegions} from "../../../../../store/entities/locations/regions/regions.selectors";
import {Regions} from "../../../../../store/entities/locations/regions/regions.model";

@Component({
  selector: 'app-service-filter-banner',
  templateUrl: './service-filter-banner.component.html',
  styleUrl: './service-filter-banner.component.scss'
})
export class ServiceFilterBannerComponent implements OnInit, OnDestroy {
  form: FormGroup;
  subscription$: Subscription = new Subscription();

  citizenSectors$: Observable<CitizensServicesSector[]>;
  servicesCategory$: Observable<CitizensServicesCategory[]>;
  ServiceClusterEnumOptions = enumToObjectArray(ServiceClusterEnumTranslate);
  specialNeedsOptions = enumToObjectArray(SocialGroups);
  regions$: Observable<Regions[]>

  @Output() formData = new EventEmitter();


  constructor(
    private fb: FormBuilder,
    private store: Store<AppState>,
  ) {

  }

  ngOnInit(): void {

    this.store.dispatch(citizenGetAllSectors({filtering: null}));
    this.store.dispatch(citizenGetCategories());
    this.store.dispatch(getAllRegions())
    this.regions$ = this.store.select(selectAllRegions);
    this.citizenSectors$ = this.store.select(selectModifiedCitizenSector);
    this.servicesCategory$ = this.store.select(selectModifiedCitizensServiceCategory);

    this.form = this.fb.group(
      {
        sectorUniqueId: ['',],
        categoryUniqueId: ['',],
        consumerGroup: [[],],
        socialGroup: [[],],
        regionUniqueId: ['',]
      }
    )
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  selectionChange(event: any, key: string) {
    this.form.get(key).patchValue(event?.value);
    const formData = this.form?.value;
    this.formData.emit(formData);
  }


}
